import { errorText } from "../lib/errors";

/**
 * Satır içi hata kutusu.
 *
 * NİÇİN: eski `post.php` her durumda "başarıyla güncellendi" dönüyordu ve
 * istemcinin hata dalı hiç çalışmıyordu. Bu bileşenin tek görevi sunucunun
 * söylediğini KAYBETMEDEN göstermek — asla "bir hata oluştu"ya indirgemez.
 */
export function ErrorNote({
  error,
  className = "",
}: {
  /** Error nesnesi, callable hatası veya düz metin. Boşsa hiçbir şey çizilmez. */
  error: unknown;
  className?: string;
}) {
  if (!error) return null;

  return (
    <div
      role="alert"
      className={`rounded-md border border-red-300 bg-red-50 px-3 py-2 text-sm text-red-800 ${className}`}
    >
      {errorText(error)}
    </div>
  );
}

export default ErrorNote;
